module.exports = __webpack_public_path__ + "manufacture-date.7e22b1976b8876ef480a.png";